import useCreateNeighborhoodPrice from 'modules/companies/hooks/use-create-neighborhood-price';
import {
  CompanyNeighborHoodPriceProps,
  translatedCompanyNeighborHoodPriceProps,
} from 'modules/companies/types';
import useCityNeighborhoodsByCompanySelect from 'modules/neighborhoods/hooks/use-city-neighborhoods-by-company-select';

import React from 'react';
import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateNeighborhoodPrice: React.FC = () => {
  const {getSelect, getPriceInput} =
    useFormInputs<CompanyNeighborHoodPriceProps>();
  const {id} = useParams();

  const {data, isLoading} = useCityNeighborhoodsByCompanySelect(id!);

  return (
    <Creation<CompanyNeighborHoodPriceProps>
      {...{
        defaultValues: {companyId: id},
      }}
      onSubmit={() => useCreateNeighborhoodPrice(id!)}
      inputs={[
        getSelect({
          name: 'neighborhoodId',
          data,
          isLoading,
        }),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
      ]}
      translationKey={translatedCompanyNeighborHoodPriceProps}
    />
  );
};

export default CreateNeighborhoodPrice;
